/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { Text, View } from '@applane/react-core-components';
import Toast from '@applane/react-toast';
import { getUser, invoke } from '../../../AppServices';
import { Form } from '../../../app-components/form/FormNoti';
import { autoSuggestOptionsInput } from '../../../autoSuggestions';
import {
  ROUTES,
  blackBookPriceType,
  selectDMS,
  selectVMPP,
} from '../../../Lib/constants';
import { settingUri } from '../../../Queries/dealer';
import { getUserRole, validateEmail } from '../../../Lib/helpers';
import vars from '../../../theme/vars';
import './switch.css'
import { BASE_URL } from '../../../Config';
import axios from 'axios';

const theme = {
  boxToHoldRules: {
    marginLeft: 16,
    marginRight: 16,
    marginBottom: 10,
    backgroundColor: vars.colors.secondary.color4,
    display: 'flex',
    flexDirection: 'column',
  },
  boxToHoldEachRule: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 16,
    color: 'grey',
    margin: '4px 0px',
  },
  boxToHoldTitle: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 20,
    textDecoration: 'underline',
    color: 'grey',
  },

  leftContainerStyle: {},

  leftDropDownStyle: {
    height: 256,
    marginLeft: -9,
    marginTop: 15,
    width: 100,
  },
};

const validations = {
  printemailid: ({ data }) => validateEmail(data?.printemailid),
  customerInterestId: ({ data }) => validateEmail(data?.customerInterestId),

  mailContent: ({ data }) => {
    if (!data?.mailContent?.includes('{finalrange}')) {
      return 'Invalid (Please Check Again)';
    }
    return false;
  },
  smsContent: ({ data }) => {
    if (data?.smsContent) {
      if (!data?.smsContent?.includes('{finalrange}')) {
        return 'Invalid (Please Check Again)';
      }
    }
    return false;
  },
  notify1: ({ data }) => {
    if (!data?.notify1) {
      return;
    }

    if (/^\d+\.?\d*$/.test(data?.notify1)) {
      if (data?.notify1 > 3 || data?.notify1 < 1) {
        return 'Enter a number between 1-3';
      }
    } else {
      return 'Enter a number between 1-3';
    }
  },
  notify2: ({ data }) => {
    if (!data?.notify2) {
      return;
    }

    if (/^\d+\.?\d*$/.test(data?.notify2)) {
      if (data?.notify2 > 3 || data?.notify2 < 1) {
        return 'Enter a number between 1-3';
      }
    } else {
      return 'Enter a number between 1-3';
    }
  },
  notify3: ({ data }) => {
    if (!data?.notify3) {
      return;
    }

    if (/^\d+\.?\d*$/.test(data?.notify3)) {
      if (data?.notify3 > 3 || data?.notify3 < 1) {
        return 'Enter a number between 1-3';
      }
    } else {
      return 'Enter a number between 1-3';
    }
  },
};
let dealerData
const hasHyperlink = (data) => {
  dealerData = data
  const mailContent = data?.mailContent;
  const smsContent = data?.smsContent;

  return (
    mailContent?.includes('{hyperlink}') || smsContent?.includes('{hyperlink}')
  );
};

const deleteDealer = async () => {


  if (dealerData?.activityStatus === "Active") {
    Toast.show({
      message: 'Warning',
      description: 'Dealer status is Active, Change status to Inactive to Delete Dealer',
      type: 'warning',
      position: 'top',
      direction: 'left',
      duration: 3000,
    });
    return
  }
  let deleteUser = await invoke({
    id: 'deleteInactiveDealers',
    paramValue: {
      dealerId: dealerData._id
    },
  });

  Toast.show({
    message: 'Success',
    description: deleteUser.message,
    type: 'success',
    position: 'top',
    direction: 'left',
    duration: 3000,
  });
}

const UserCheckBox = () => {
  const dealerData = getUser()

  const [isChecked, setIsChecked] = useState(dealerData?.dealer?.dealerReceiveOffers);
  console.log('isChecked', isChecked)

  const handleCheckboxChange = (event) => {
    if (isChecked) {
      setIsChecked(false);
    } else if (!isChecked) {
      setIsChecked(true);
    }
    console.log(isChecked)
    dealerReceiveOffersEmail()
  };

  const dealerReceiveOffersEmail = async () => {
    try {
      const updateSettings = await invoke({
        id: 'dealerReceiveOffersEmail',
        paramValue: {
          data: {
            dealerId: dealerData.dealer._id,
            dealerReceiveOffers: isChecked ? false : true
          }
        },
      });

      // Toast.show({
      //   message: 'Success',
      //   description: updateSettings.message,
      //   type: 'success',
      //   position: 'top',
      //   direction: 'left',
      //   duration: 5000,
      // });

      // Additional logic if needed after successful deletion
    } catch (error) {
      // Handle errors if the deletion fails
      console.error('Error deleting inactive dealer:', error);
    }
  };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>If you want to receive the offers email that we have sent to the customer, click on the button below.</p>

      <div>
        <label class="switch">
          <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}

const UserWeekReport = () => {
  const dealerData = getUser()
  console.log('dealerData?.dealer?.dealerReceiveOffersEmail', dealerData?.dealer)
  const [isChecked, setIsChecked] = useState(dealerData?.dealer?.dealerWeeklyReport === 'Yes' ? true : false);

  console.log('isCheckedUserWeekReport', isChecked)

  const handleCheckboxChange = (event) => {
    if (isChecked) {
      setIsChecked(false);
    } else if (!isChecked) {
      setIsChecked(true);
    }
    console.log('isCheckedUserWeekReport', isChecked)
    dealerReceiveWeeklyReport()
  };

  const dealerReceiveWeeklyReport = async () => {
    try {
      const updateSettings = await invoke({
        id: 'dealerReceiveWeeklyReport',
        paramValue: {
          data: {
            dealerId: dealerData.dealer._id,
            dealerWeeklyReport: isChecked ? 'No' : 'Yes'
          }
        },
      });

      // Toast.show({
      //   message: 'Success',
      //   description: updateSettings.message,
      //   type: 'success',
      //   position: 'top',
      //   direction: 'left',
      //   duration: 5000,
      // });

      // Additional logic if needed after successful deletion
    } catch (error) {
      // Handle errors if the deletion fails
      console.error('Error deleting inactive dealer:', error);
    }
  };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        If you wish to receive the weekly report for your account, including details such as Appraisals Captured, Generated, and Failed, click on the button below.</p>

      <div>
        <label class="switch">
          <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}

const UserModalWeeklyReport = () => {
  const dealerData = getUser()
  const [isChecked, setIsChecked] = useState(dealerData?.dealer?.dealerModalWeeklyReport === 'Yes' ? true : false);


  const handleCheckboxChange = (event) => {
    if (isChecked) {
      setIsChecked(false);
    } else if (!isChecked) {
      setIsChecked(true);
    }
    console.log('isCheckedUserWeekReport', isChecked)
    dealerModalWeeklyReport()
  };

  const dealerModalWeeklyReport = async () => {
    try {
      const updateSettings = await invoke({
        id: 'dealerReceiveModalWiseWeekly',
        paramValue: {
          data: {
            dealerId: dealerData.dealer._id,
            dealerModalWeeklyReport: isChecked ? 'No' : 'Yes'
          }
        },
      });

      // Toast.show({
      //   message: 'Success',
      //   description: updateSettings.message,
      //   type: 'success',
      //   position: 'top',
      //   direction: 'left',
      //   duration: 5000,
      // });

      // Additional logic if needed after successful deletion
    } catch (error) {
      // Handle errors if the deletion fails
      console.error('Error deleting inactive dealer:', error);
    }
  };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        If you would like to receive the weekly report of appraisals generated, categorized by models, click on the button below.</p>

      <div>
        <label class="switch">
          <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}


const CustomerInterestNoti = () => {
  const dealerData = getUser()
  console.log('dealerData', dealerData)
  const [isChecked, setIsChecked] = useState(dealerData?.dealer?.customerInterestNoti === 'Yes' ? true : false);


  const handleCheckboxChange = (event) => {
    if (isChecked) {
      setIsChecked(false);
    } else if (!isChecked) {
      setIsChecked(true);
    }
    console.log('isCheckedUserWeekReport', isChecked)
    dealerModalWeeklyReport()
  };

  const dealerModalWeeklyReport = async () => {
    try {
      const updateSettings = await invoke({
        id: 'customerInterestNotification',
        paramValue: {
          data: {
            dealerId: dealerData.dealer._id,
            customerInterestNoti: isChecked ? 'No' : 'Yes'
          }
        },
      });

      // Toast.show({
      //   message: 'Success',
      //   description: updateSettings.message,
      //   type: 'success',
      //   position: 'top',
      //   direction: 'left',
      //   duration: 5000,
      // });

      // Additional logic if needed after successful deletion
    } catch (error) {
      // Handle errors if the deletion fails
      console.error('Error deleting inactive dealer:', error);
    }
  };



  return (
    <div>
      <hr />

      <p style={{ fontSize: '1.5rem', marginBottom: '20px' }}>
        If you would like to receive notifications when a customer shows interest in an appraisal offer, click on the button below.
      </p>
      <div>
        <label class="switch">
          <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  )
}


// const ChangeLogo = () => {
//   const dealerData = getUser(); // Assuming getUser() retrieves the dealer data

//   const [logoFile, setLogoFile] = useState(null);

//   const handleFileChange = (event) => {
//     setLogoFile(event.target.files[0]);
//   };

//   const uploadLogo = async () => {
//     try {
//       const token = localStorage.getItem('token'); // Retrieve token from localStorage

//       if (!logoFile) {
//         // Show a message if no file is selected
//         Toast.show({
//           message: 'Error',
//           description: 'Please select a file to upload',
//           type: 'error',
//           position: 'top',
//           direction: 'left',
//           duration: 5000,
//         });
//         return;
//       }

//       const formData = new FormData();
//       formData.append('dealerLogo', logoFile);
//       formData.append('dealerId', dealerData.dealer._id);

//       const data = {
//         id: 'dealerLogo',
//         paramValue: {
//           formData
//         },
//         token: token, // Include token in the request
//       };

//       const response = await axios.post(BASE_URL + '/invoke', data, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       const updateSettings = response.data;

//       Toast.show({
//         message: 'Success',
//         description: updateSettings.message,
//         type: 'success',
//         position: 'top',
//         direction: 'left',
//         duration: 5000,
//       });

//       // Additional logic if needed after successful logo upload
//     } catch (error) {
//       // Handle errors if the upload fails
//       console.error('Error uploading dealer logo:', error);
//       Toast.show({
//         message: 'Error',
//         description: 'Failed to upload logo',
//         type: 'error',
//         position: 'top',
//         direction: 'left',
//         duration: 5000,
//       });
//     }
//   };

//   return (
//     <div>
//       <hr />

//       <h4 className="button-upload">Upload a Logo</h4>

//       <input type="file" onChange={handleFileChange} />

//       <button onClick={uploadLogo}>Upload</button>
//     </div>
//   );
// };


// User
const ChangeLogo = () => {
  const dealerData = getUser(); // Assuming getUser() retrieves the dealer data
  console.log('dealerData', dealerData)
  const [logoFile, setLogoFile] = useState(null);

  const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
  const maxFileSize = 100 * 1024; // 100 KB
  const maxDimensions = { width: 200, height: 200 };
  const [link, setLink] = useState(false)
  const [imgLink, setImgLink] = useState('')
  console.log('imgLink', imgLink)
  const getImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const dimensions = {
          width: img.width,
          height: img.height
        };
        resolve(dimensions);
      };

      img.onerror = () => {
        reject(new Error('Failed to load image'));
      };

      img.src = URL.createObjectURL(file);
    });
  };


  const handleFileChange = async (event) => {
    console.log('handleFileChange');
    const file = event.target.files[0];

    if (!file) {
      Toast.show({
        message: 'Error',
        description: 'No file selected',
        type: 'error',
        position: 'top',
        direction: 'left',
        duration: 5000,
      });
      return;
    }

    // Check file type
    if (!allowedTypes.includes(file.type)) {
      Toast.show({
        message: 'Error',
        description: 'Unsupported file type. Please select a valid image file (jpg, png, gif)',
        type: 'error',
        position: 'top',
        direction: 'left',
        duration: 5000,
      });
      return;
    }

    // Check file size
    if (file.size > maxFileSize) {
      Toast.show({
        message: 'Error',
        description: 'File size exceeds the limit. Please select a file less than 100 KB',
        type: 'error',
        position: 'top',
        direction: 'left',
        duration: 5000,
      });
      setLink(true)
      return;
    }

    try {
      const dimensions = await getImageDimensions(file);
      console.log('Image dimensions:', dimensions);
      // Do something with dimensions (e.g., validate dimensions)
      if (dimensions.width > maxDimensions.width || dimensions.height > maxDimensions.height) {
        Toast.show({
          message: 'Error',
          description: `Image dimensions exceed the limit. Maximum dimensions: ${maxDimensions.width} x ${maxDimensions.height}px`,
          type: 'error',
          position: 'top',
          direction: 'left',
          duration: 5000,
        });
        setLink(true)
        return;
      }



      setLogoFile(file);
    } catch (error) {
      console.error('Error getting image dimensions:', error);
      // Handle error
    }
  };
  console.log('logofile', logoFile)




  const uploadLogo = async () => {
    try {
      const token = localStorage.getItem('token'); // Retrieve token from localStorage

      if (imgLink) {
        const update = await invoke({
          id: 'dealerLogo',
          paramValue: {
            data: {
              dealerId: dealerData.dealer._id,
              dealerLogo: imgLink
            }
          },
        });

        Toast.show({
          message: 'Success',
          description: update.message,
          type: 'success',
          position: 'top',
          direction: 'left',
          duration: 5000,
        });

        console.log('New', update)
        window.location.reload()
      } else {

        if (!logoFile) {
          // Show a message if no file is selected
          Toast.show({
            message: 'Error',
            description: 'Please select a file to upload',
            type: 'error',
            position: 'top',
            direction: 'left',
            duration: 5000,
          });
          return;
        }

        const formData = new FormData();
        formData.append('dealerLogo', logoFile);
        formData.append('dealerId', dealerData.dealer._id);
        console.log("formData", formData)


        const response = await axios.post(BASE_URL + '/dealerLogo', formData);

        const updateSettings = response.data;

        Toast.show({
          message: 'Success',
          description: updateSettings.message,
          type: 'success',
          position: 'top',
          direction: 'left',
          duration: 5000,
        });

        if (updateSettings.success) {

          const update = await invoke({
            id: 'dealerLogo',
            paramValue: {
              data: {
                dealerId: dealerData.dealer._id,
                dealerLogo: updateSettings.filename
              }
            },
          });
          console.log('New', update)
          window.location.reload()
        }
      }

    } catch (error) {
      // Handle errors if the upload fails
      console.error('Error uploading dealer logo:', error);
      Toast.show({
        message: 'Error',
        description: 'Failed to upload logo',
        type: 'error',
        position: 'top',
        direction: 'left',
        duration: 5000,
      });
    }
  };


  const deleteLogo = async () => {
    try {

      if (dealerData?.dealer?.dealerLogo.startsWith("http")) {
        const dltLogo = await invoke({
          id: 'dealerLogo',
          paramValue: {
            data: {
              dealerId: dealerData.dealer._id,
              dealerLogo: 'delete'
            }
          },
        });
        console.log('New', dltLogo)

        Toast.show({
          message: 'Success',
          description: dltLogo.message,
          type: 'success',
          position: 'top',
          direction: 'left',
          duration: 5000,
        });

        window.location.reload()
      } else {
        const response = await axios.delete(`${BASE_URL}/deleteFile/${dealerData?.dealer?.dealerLogo}`);

        const { success, message } = response.data;

        if (success) {
          // Handle success message
          const dltLogo = await invoke({
            id: 'dealerLogo',
            paramValue: {
              data: {
                dealerId: dealerData.dealer._id,
                dealerLogo: 'delete'
              }
            },
          });
          console.log('New', dltLogo)

          Toast.show({
            message: 'Success',
            description: message,
            type: 'success',
            position: 'top',
            direction: 'left',
            duration: 5000,
          });

          window.location.reload()
        } else {
          // Handle failure message
          Toast.show({
            message: 'Error',
            description: message,
            type: 'error',
            position: 'top',
            direction: 'left',
            duration: 5000,
          });
        }
      }
    } catch (error) {
      // Handle error
      console.error('Error deleting logo:', error);
      Toast.show({
        message: 'Error',
        description: 'Failed to delete logo',
        type: 'error',
        position: 'top',
        direction: 'left',
        duration: 5000,
      });
    }
  };


  return (
    <div>
      <hr />

      <h4 className="button-upload d-flex align-items-center">Dealer Logo:     
      {!dealerData?.dealer?.dealerLogo &&
        <span className='d-flex justify-content-between' style={{ width: '200px', cursor: 'pointer', fontSize: '12px', paddingLeft: '10px' }}>
        {link ?
          <p style={{ color: 'blue' }} onClick={() => { setLink(false) }}>
            <u> Logo Upload by File </u>
          </p> :
          <p style={{ color: 'blue' }} onClick={() => { setLink(true) }}>
            <u>Logo Upload by Link </u>
          </p>
        }
      </span>
      }
      
      </h4>



      {(logoFile || imgLink) ?


        <div style={{ maxWidth: '400px', maxHeight: '400px' }}>
          <div>
            {imgLink ?
              <img src={imgLink} alt="Uploaded Logo" style={{ maxWidth: '200px', maxHeight: '200px' }} /> :
              <img src={URL.createObjectURL(logoFile)} alt="Uploaded Logo" />}
          </div>
        </div>
        :


        dealerData?.dealer?.dealerLogo &&

        <div style={{ maxWidth: '400px', maxHeight: '400px' }}>
          <div>
            <img
              src={
                dealerData?.dealer?.dealerLogo.startsWith("http")
                  ? dealerData?.dealer?.dealerLogo
                  : `${BASE_URL}/dealerLogo/${dealerData?.dealer?.dealerLogo}`
              }
              alt="Uploaded Logo"
              style={{ maxWidth: '200px', maxHeight: '200px' }}

            />          </div>
        </div>
      }

      <div className='d-flex mt-2' style={{ width: '300px' }}>


        {!dealerData?.dealer?.dealerLogo &&

          link ?
          <div style={{ maxWidth: '400px', maxHeight: '400px' }}>
            <input placeholder='Image link' onChange={(e) => { setImgLink(e.target.value) }} style={{ borderRadius: '10px' }} className='me-4' />
          </div>

          :
          !dealerData?.dealer?.dealerLogo && <input type="file" accept="image/*" onChange={handleFileChange} />}




        {(logoFile || imgLink) &&
          <button onClick={uploadLogo} className='px-4 py-2 ' style={{ border: 'none', background: 'blue', color: 'white', borderRadius: '10px' }}>Upload</button>
        }

        {dealerData?.dealer?.dealerLogo && <button onClick={deleteLogo} className='px-4 py-2 mx-1' style={{ border: 'none', background: 'red', color: 'white', borderRadius: '10px' }}>Delete</button>}

      </div>
      {!dealerData?.dealer?.dealerLogo &&
        <div className='mt-3' style={{ fontSize: '1.2rem', color: 'gray' }}>
          Allowed file types: jpeg, png, gif.<br />
          Max file size: {maxFileSize / 1024} KB.<br />
          Max dimensions: {maxDimensions.width} x {maxDimensions.height} pixels.
        </div>
      }

    </div>
  );
};



const Modal = ({ props }) => {
  const dealerName = props?.navigation?.state?.params?.item?.username
  return (
    <div class="modal fade" id="basicModal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          {/* <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div> */}
          <div class="modal-body">
            <h4>Are you sure you want to delete this dealer. <br /> Dealer Name : {dealerName}?</h4>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal" onClick={deleteDealer}>Yes</button>
          </div>
        </div>
      </div>
    </div>
  )
}
const SettingScreen = (props) => (

  <>
    <Modal props={props} />
    <Form
      type="standard"
      uri={settingUri}
      bodyContainerStyle={{
        marginLeft: 16,
        marginRight: 16,
        marginBottom: 24,
        borderRadius: 4,
        backgroundColor: vars.colors.secondary.color4,
      }}
      mandatory={{
        dms: 1,
        vmpp: 1,
        apidms: ({ data }) => (data?.dms === 'CDK Global' || data.dms === 'Meadowland Systems Inc.'
          ? 1
          : 0),
        qparamInvCompany: ({ data }) => (data?.dms === 'CDK Global' ? 1 : 0),
        apivmpp: ({ data }) => (data?.vmpp === 'Galves' ? 1 : 0),
        blackBookPriceType: ({ data }) => (data?.vmpp === 'Black Book' ? 1 : 0),
        mailContent: 1,
        smsContent: 1,
        interestContent: 1,
        notifyType: 1,
        'opentrackDealerData.companyNumber': ({ data }) => (data?.dms === 'Dealertrack DMS' ? 1 : 0),
        'opentrackDealerData.enterpriseCode': ({ data }) => (data?.dms === 'Dealertrack DMS' ? 1 : 0),
        hyperlinkLabel: ({ data }) => hasHyperlink(data),
        hyperlink: ({ data }) => hasHyperlink(data),
      }}
      onSubmit={async ({ data, navigation }) => {
        const {
          notify1, notify2, notify3, notifyType,
        } = data;

        let notifyPreference = [];

        if (notifyType === 'All') {
          notifyPreference = ['Email', 'SMS', 'Print'];
        } else if (!notify1 && !notify2 && !notify3) {
          Toast.show({
            message: 'Error',
            description: 'Add atleast one option for notification!',
            type: 'error',
            position: 'top',
            direction: 'right',
            duration: 3000,
          });
        } else {
          if (notify1) {
            notifyPreference[notify1 - 1] = 'Email';
          }
          if (notify2) {
            notifyPreference[notify2 - 1] = 'SMS';
          }
          if (notify3) {
            notifyPreference[notify3 - 1] = 'Print';
          }
        }

        if (notifyPreference.length) {
          await invoke({
            id: 'checkNotificationFields',
            paramValue: {
              dealerId:
                getUserRole() === 'dealer'
                  ? getUser()?.dealer?._id
                  : navigation?.state?.params?.item?._id,
            },
          });

          const myUpdates = {
            dms: data.dms,
            apidms: data.apidms,
            invLinkId: data.invLinkId,
            qparamInvCompany: data.qparamInvCompany,
            opentrackDealerData: {
              companyNumber: data.opentrackDealerData?.companyNumber,
              enterpriseCode: data.opentrackDealerData?.enterpriseCode,
            },
            vmpp: data.vmpp,
            apivmpp: data.apivmpp,
            blackBookPriceType: data.blackBookPriceType,
            printemailid: data.printemailid,
            customerInterestId: data.customerInterestId,
            notifyType: data?.notifyType,
            notifyPreference,
            notify1: data?.notify1,
            notify2: data?.notify2,
            notify3: data?.notify3,
            mailContent: data.mailContent,
            smsContent: data.smsContent,
            interestContent: data.interestContent,
            hyperlinkLabel: hasHyperlink(data) ? data.hyperlinkLabel : '',
            hyperlink: hasHyperlink(data) ? data.hyperlink : '',
          };

          await invoke({
            id: 'updateSettings',
            paramValue: {
              data: myUpdates,
              dealerId:
                getUserRole() === 'dealer'
                  ? getUser()?.dealer?._id
                  : navigation?.state?.params?.item?._id,
            },
          });

          Toast.show({
            message: 'Success',
            description: 'Settings Saved Successfully!',
            type: 'success',
            position: 'top',
            direction: 'left',
            duration: 3000,
          });

          if (navigation?.state?.routeName === ROUTES.dealerSettingsBack.name) {
            navigation.pop();
          }
        }
      }}
      validations={validations}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            label: 'General',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  autoSuggestOptionsInput({
                    label: 'DMS',
                    field: 'dms',
                    suggestionField: 'label',
                    valueField: 'label',
                    options: selectDMS,
                    keyField: 'value',
                    mandatory: true,
                  }),
                  {
                    type: 'text',
                    field: 'apidms',
                    label: 'Dealer ID',
                    mandatory: true,
                    allowWhiteSpaces: false,
                    editable: true,
                    visible: ({ data = {} }) => data.dms === 'CDK Global'
                      || data.dms === 'Meadowland Systems Inc.' || data.dms === 'Tekion' || data.dms === 'PBS Systems' || data.dms === 'Reynolds'
                  },
                  {
                    type: 'text',
                    field: 'invLinkId',
                    label: 'Inventory Relation ID',
                    allowWhiteSpaces: false,
                    editable: true,
                  },
                  {
                    type: 'text',
                    field: 'qparamInvCompany',
                    label: 'Inv Company No.',
                    mandatory: true,
                    allowWhiteSpaces: false,
                    editable: true,
                    visible: ({ data = {} }) => data.dms === 'CDK Global',
                  },
                  {
                    type: 'text',
                    field: 'opentrackDealerData.companyNumber',
                    label: 'Company Number',
                    mandatory: true,
                    allowWhiteSpaces: false,
                    editable: true,
                    visible: ({ data = {} }) => data.dms === 'Dealertrack DMS',
                  },
                  {
                    type: 'text',
                    field: 'opentrackDealerData.enterpriseCode',
                    label: 'Enterprise Code',
                    mandatory: true,
                    allowWhiteSpaces: false,
                    editable: true,
                    visible: ({ data = {} }) => data.dms === 'Dealertrack DMS',
                  },
                  // autoSuggestOptionsInput({
                  //   label: 'VMPP',
                  //   field: 'vmpp',
                  //   suggestionField: 'label',
                  //   valueField: 'label',
                  //   options: selectVMPP,
                  //   keyField: 'label',
                  //   mandatory: true,
                  // }),
                  // {
                  //   type: 'text',
                  //   field: 'apivmpp',
                  //   label: 'Enter VMPP API key',
                  //   mandatory: true,
                  //   allowWhiteSpaces: false,
                  //   editable: true,
                  //   visible: ({ data = {} }) => data?.vmpp === 'Galves',
                  // },
                  {
                    type: 'radioGroup',
                    field: 'blackBookPriceType',
                    label: 'Choose price type for vmpp',
                    options: blackBookPriceType,
                    mandatory: true,
                    visible: ({ data = {} }) => {
                      if (data.vmpp === 'Black Book') {
                        return true;
                      }
                      return false;
                    },
                  },
                  {
                    type: 'text',
                    field: 'printemailid',
                    label: 'Print Email Id',
                  },
                  {
                    type: 'text',
                    field: 'customerInterestId',
                    label: 'CUSTOMER INTEREST REPLY EMAIL / CUSTOMER INTEREST REPORT EMAIL',
                  },
                ],
              },
            ],
          },

          // notification radio
          {
            columnsPerRow: 1,
            fieldVariant: 'filled',
            label: 'Notification',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  {
                    type: 'radioGroup',
                    field: 'notifyType',
                    variant: 'filled',
                    label: 'Notify Preference',
                    description:
                      '1: Highest Priority.<br>2: Middle Priority.<br>3: Lowest Priority',
                    // description:
                    //   'Set order of notification to send to customer.',
                    container: 'topLabel',
                    options: ['Select Order', 'All'],
                  },
                ],
              },
            ],
          },

          // notification preferences
          {
            columnsPerRow: 3,
            fieldVariant: 'filled',
            label: 'Notification Order',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groups: [
              {
                columns: [
                  {
                    type: 'text',
                    label: 'Email',
                    field: 'notify1',
                    visible: ({ data = {} }) => data?.notifyType === 'Select Order',
                  },
                  {
                    type: 'text',
                    label: 'SMS',
                    field: 'notify2',
                    visible: ({ data }) => data?.notifyType === 'Select Order',
                  },
                  {
                    type: 'text',
                    label: 'Print',
                    field: 'notify3',
                    visible: ({ data }) => data?.notifyType === 'Select Order',
                  },
                ],
              },
            ],
          },

          // templates
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            label: 'Templates',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  {
                    type: 'textArea',
                    field: 'mailContent',
                    label: 'Email Template',
                    description:
                      'use {field_name} where the value needs to be inserted.',
                    mandatory: true,
                    editable: true,
                    allowWhiteSpaces: true,
                    minHeight: 100,
                    style: { flex: 1, overflow: 'hidden' },
                  },
                  {
                    type: 'textArea',
                    field: 'smsContent',
                    label: 'SMS Template',
                    description:
                      'use {field_name} where the value needs to be inserted.',
                    mandatory: true,
                    editable: true,
                    allowWhiteSpaces: true,
                    minHeight: 100,
                    style: { flex: 1, overflow: 'hidden' },
                  },
                  {
                    type: 'textArea',
                    field: 'interestContent',
                    label: 'Customer Interest Template',
                    description:
                      `Upon clicking the 'Interest' link, customers will be directed to our Thank You page. This message serves to inform them about this redirection and expresses gratitude for their engagement.`,
                    mandatory: true,
                    editable: true,
                    allowWhiteSpaces: true,
                    minHeight: 100,
                    style: { flex: 1, overflow: 'hidden' },
                  },
                  {
                    type: 'text',
                    label: 'Hyperlink To Be Shown',
                    field: 'hyperlinkLabel',
                    visible: ({ data }) => hasHyperlink(data),
                    allowWhiteSpaces: true,
                  },
                  {
                    type: 'text',
                    label: 'Link attached to hyperlink',
                    field: 'hyperlink',
                    visible: ({ data }) => hasHyperlink(data),
                  },



                  // getUserRole() === 'superadmin' && (
                  //   <>


                  //     <hr />
                  //     <p style={{ fontSize: '1.8rem', marginBottom: '20px' }}>If you want to delete the Dealer, click the button below.</p>

                  //     <button
                  //       style={{
                  //         border: 0,
                  //         width: "120px",
                  //         padding: "10px 0 10px 0",
                  //         margin: "20px 0 20px 0px",
                  //         borderRadius: "10px",
                  //       }}
                  //       className='btn btn-danger'
                  //       data-toggle="modal"
                  //       data-target="#basicModal"
                  //     // onClick={deleteDealer}                     
                  //     >
                  //       Delete Dealer
                  //     </button>
                  //   </>
                  // )

                ],
              },
            ],
          },


          {
            columnsPerRow: 2,
            groups: [
              {
                columns: [

                  getUserRole() === 'superadmin' && (
                    <>
                      <hr />
                      <p style={{ fontSize: '1.8rem', marginBottom: '20px' }}>If you want to delete the Dealer, click the button below.</p>

                      <button
                        style={{
                          border: 0,
                          width: "120px",
                          padding: "10px 0 10px 0",
                          margin: "20px 0 20px 0px",
                          borderRadius: "10px",
                        }}
                        className='btn btn-danger'
                        data-toggle="modal"
                        data-target="#basicModal"
                      // onClick={deleteDealer}                     
                      >
                        Delete Dealer
                      </button>
                    </>
                  ),
                  getUserRole() === 'dealer' &&
                  <UserCheckBox props={dealerData} />
                  ,
                  getUserRole() === 'dealer' &&
                  <UserWeekReport props={dealerData} />
                  ,
                  getUserRole() === 'dealer' &&
                  <UserModalWeeklyReport props={dealerData} />
                  ,
                  getUserRole() === 'dealer' &&
                  <CustomerInterestNoti props={dealerData} />
                  ,
                ],
              },
            ],
          },

          {
            columnsPerRow: 2,
            groups: [
              {
                columns: [

                  getUserRole() === 'dealer' &&
                  <ChangeLogo props={dealerData} />
                  ,
                ],
              },
            ],
          },

        ],
      }}
      {...props}
    />


    <View style={theme.boxToHoldRules}>
      <View style={theme.boxToHoldTitle}>Rules for templates</View>

      <View style={theme.boxToHoldEachRule}>
        <Text>{'Envelope a value in {} brackets while writing template.'}</Text>
        <Text>
          {
            'For example, hello customer your vehicle appraisal price is {finalrange}.'
          }
        </Text>
        <Text>{'or, please visit on this {hyperlink}.'}</Text>
      </View>
    </View>
  </>
);

export default SettingScreen;
